import { DateUtils } from './DateUtils';

const checkPaxChange = (prev, next, changes) => {
    try {
        if (prev.pax.adults !== next.pax.adults ||
            prev.pax.infants !== next.pax.infants ||
            prev.pax.kids !== next.pax.kids ||
            prev.cabinClass !== next.cabinClass
        ) {
            changes.pax = true;
        }
    } catch (err) { return; }
};

const checkSegmentChange = (prev, next, changes) => {
    try {
        next.segments.forEach(({ origin, destination }, i) => {
            const { origin: prevOrigin, destination: prevDestination } = prev.segments[i];
            if (origin && prevOrigin && prevOrigin.geoNodeId !== origin.geoNodeId) {
                changes.destinations = true;
            }
            if (destination && prevDestination && prevDestination.geoNodeId !== destination.geoNodeId) {
                changes.destinations = true;
            }
        });
    } catch (err) { return; }
};

const checkValid = (prev, next, changes) => {
    if (changes.lastRT[0] && changes.lastRT[1] && next.tripType === 'roundTrip') {
        if (DateUtils.getTime(next.segments[0].date) === changes.lastRT[0] &&
            DateUtils.getTime(next.segments[1].date) === changes.lastRT[1] ) {
            changes.dates = [false, false, false];
            return;
        }
        if (DateUtils.getTime(next.segments[0].date) &&
            DateUtils.getTime(next.segments[1].date) &&
            (DateUtils.getTime(next.segments[0].date) !== changes.lastRT[0] || DateUtils.getTime(next.segments[0].date) !== changes.lastRT[0])) {
            changes.dates = [true, true, false];
            changes.lastRT = [DateUtils.getTime(next.segments[0].date), DateUtils.getTime(next.segments[1].date)];
            return;
        }
    }
};
const processSegment = (prev, next, changes) => {
    next.segments.forEach((el, i) => {
        const { date: prevDate } = prev.segments[i] || 0;
        if (!DateUtils.getTime(prevDate) && DateUtils.getTime(el.date)) {
            changes.dates[i] = true;
            if (next.tripType === 'roundTrip') { changes.lastRT[i] = DateUtils.getTime(el.date); }
            return;
        }
        if (DateUtils.getTime(prevDate) && DateUtils.getTime(el.date) && DateUtils.getTime(prevDate) !== DateUtils.getTime(el.date)) {
            changes.dates[i] = true;
        }
    });
};
const checkDateChange = (prev, next, changes) => {
    try {
        checkValid(prev, next, changes);
        processSegment(prev, next, changes);
    } catch (err) { return; }
};

const convertTripType = (type) => {
    return {
        roundTrip: 'ROUND_TRIP',
        oneWayTrip: 'ONE_WAY',
        multipleTrip: 'MULTIPLE_DESTINATIONS',
    }[type];
};

const convertUrl = (params) => {
    const { protocol, host } = window.location;
    return `${protocol}//${host}/travel/#results/${params}`;
};

const convert = (data, params) => {
    return {
        itinerarySearchRequest: {
            type: convertTripType(data.type),
            numAdults: data.numAdults,
            numChildren: data.numChildren,
            numInfants: data.numInfants,
            cabinClass: data.cabinClass,
            mainAirportsOnly: false,
            directFlightsOnly: data.directFlightsOnly,
            searchMainProductType: 'FLIGHT',
            airlinesCodes: data.airlinesCodes,
            externalSelectionRequest: {},
            dynpackSearch: false,
            segmentRequests: data.searchSegments.map((segment) => ({
                dateStr: segment.dateStr,
                date: segment.dateStr,
                departure: {
                    iata: segment.departure.iata,
                    name: segment.departure.name,
                    geoNodeId: segment.departure.geoNodeId,
                    type: segment.departure.type,
                },
                destination: {
                    iata: segment.destination.iata,
                    name: segment.destination.name,
                    geoNodeId: segment.destination.geoNodeId,
                    type: segment.destination.type,
                },
                time: '0000',
            })),
            urlSearch: convertUrl(params),
        },
        buyPath: data.buyPath,
    };
};

const preSearch = (data, params) => {
    const url = '/travel/service/flow/search';
    if ('serviceWorker' in navigator && navigator.serviceWorker.controller !== null) {
        fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(convert(data, params)),
        });
    }
};

export const PreSearchUtils = {
    checkPaxChange,
    checkDateChange,
    checkSegmentChange,
    preSearch,
};
